// Utilities
import { getRecipeValidityState } from '@builder/core/recipe';
import { builderFetch } from '@builder/core/utilities';
import { html } from 'lit';
const { confirm } = _uo.utility;

/**
 * Changes the status of the recipe
 *
 * @param {Boolean} wantsToSwitchOn Whether to switch the recipe on or off
 * @param {Boolean} draftRequiresConfirmation Whether to confirm the switch to draft
 * @return {Promise} The apiFetch promise
 */
const setRecipeStatus = async ( wantsToSwitchOn, draftRequiresConfirmation = true ) => {
	// Event name
	const eventName = 'uap/builder/core/recipe/set-status';

	// If the user wants to set the recipe live, check if the recipe is valid
	if ( wantsToSwitchOn && ! getRecipeValidityState().isValid ) {
		// Stop here. getRecipeValidityState will show the error message
		return;
	}

	// Confirm if the user wants to set the recipe to draft
	if ( ! wantsToSwitchOn && draftRequiresConfirmation ) {
		await confirm( {
			content: html`
				<uo-alert type="warning">
					${ _uo.utility.escHTML( wp.i18n.__( 'Are you sure you want to set this recipe to draft? This will stop it from being triggered.', 'uncanny-automator' ) ) }
				</uo-alert>
			`
		} );
	}

	// Save the recipe title
	return builderFetch( {
		eventName: eventName,
		endpoint: 'change_post_status',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			recipe_id: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			post_ID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			post_status: wantsToSwitchOn ? 'publish' : 'draft',
		},
		snackbar: {
			loading: wantsToSwitchOn ? _uo.utility.escHTML( wp.i18n.__( 'Setting recipe to Live', 'uncanny-automator' ) ) : _uo.utility.escHTML( wp.i18n.__( 'Setting recipe to Draft', 'uncanny-automator' ) ),
			success: wantsToSwitchOn ? _uo.utility.escHTML( wp.i18n.__( 'Recipe set to Live successfully', 'uncanny-automator' ) ) : _uo.utility.escHTML( wp.i18n.__( 'Recipe set to Draft successfully', 'uncanny-automator' ) ),
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( eventName, {
				detail: {
					isRecipeOn: wantsToSwitchOn,
				}
			} ) );
		}

		return response;
	} );
}

export default setRecipeStatus;
